import { createContext } from 'react'

import type { RealTimeContextData } from './types'
import { DashBuilderStatus } from './types'

const STUB_CONTEXT_DATA: RealTimeContextData = {
  yDocRef: { current: null },
  dashMapRef: { current: null },
  dashMapSectionsRef: { current: null },
  isHocusPocusConnected: false,
  updateDashboardTheme: () => undefined,
  sendStateless: () => undefined,
  connectedUsers: [],
  handleUndoRedo: _action => {},
  resetUndoManager: () => {},
  updateUserState: _state => undefined,
  dashBuilderStatus: DashBuilderStatus.Default,
}

export const RealTimeContext = createContext(STUB_CONTEXT_DATA)
